import React from 'react';
import { withRouter } from 'react-router-dom';

class GridMov extends React.Component {

    constructor() {

        super();

        this.state = {
            pageNum: 1,
            totalPages: 0,
            pages: [[]],
            checkBox: [],
            checkAll: false,
            total: 0
        };

        this.pageDown = this.pageDown.bind(this);
        this.pageUp = this.pageUp.bind(this);
        this.abrir = this.abrir.bind(this);
        this.downloadNotaFiscal = this.downloadNotaFiscal.bind(this);
        this.downloadCorrNotaFiscal = this.downloadCorrNotaFiscal.bind(this);
        this.downloadComprovante = this.downloadComprovante.bind(this);
        this.downloadCorrComprovante = this.downloadCorrComprovante.bind(this);
        this.addAll = this.addAll.bind(this);
        this.addValor = this.addValor.bind(this);

    }

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }   

            c++;

        }   

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    desformatarValor(s) {
        if (s === null) return "";
        return s.replace(",", ".");
    }

    formatarValor(s) {
        if (s === null) return "";
        return this.moneyMask(s);
    }

    formatarTexto(txt) {
        if (txt === null) return "";
        if (txt.length <= 40) return txt;
        return txt.substring(0, 40) + " ...";
    }

    pageDown() {

        if (this.state.pageNum > 1) {
            this.setState({ pageNum: this.state.pageNum - 1 });
        }

    }

    pageUp() {

        if (this.state.pageNum < this.state.totalPages) {
            this.setState({ pageNum: this.state.pageNum + 1 });
        }

    }

    abrir(row, pn, i) {

        let indx = (10 * (pn - 1)) + i;
        let vecMovPrev = this.props.data.slice();
        let vecMov = vecMovPrev.splice(indx);

        this.props.history.push({
            pathname: this.props.linkTo,
            state: {
                row: row,
                filtroAno: this.props.filtroAno,
                filtroMes: this.props.filtroMes,
                vecMovPrev: vecMovPrev,
                vecMov: vecMov
            }
        });

    }

    downloadNotaFiscal(id, notaFiscal) {

        fetch("/api/movimentacao/download/nf/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = id + "_nf_" + notaFiscal;
            a.click();

        });

    }

    downloadCorrNotaFiscal(id, corrNotaFiscal) {

        fetch("/api/movimentacao/download/corrnf/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = id + "_cnf_" + corrNotaFiscal;
            a.click();

        });

    }

    downloadComprovante(id, comprovante) {

        fetch("/api/movimentacao/download/cp/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = id + "_cp_" + comprovante;
            a.click();

        });

    }

    downloadCorrComprovante(id, corrComprovante) {

        fetch("/api/movimentacao/download/corrcp/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = id + "_ccp_" + corrComprovante;
            a.click();

        });

    }

    addAll(e) {

        let total = 0;
        let checkBox = this.state.checkBox.slice();
        let check = !this.state.checkAll;
        this.setState({ checkAll: check });

        if (check) {

            for (let i=0; i<this.props.data.length; i++) {

                checkBox[i] = true;

                if (this.props.data[i].err_valor !== 1 && this.props.data[i].err_valor !== 2
                    && this.props.data[i].err_valor !== 4) {
                    total += this.props.data[i].valor;
                } else {
                    total += this.props.data[i].corr_valor;
                }

            }

            this.setState({ total: total });
            this.setState({ checkBox: checkBox });

        } else {

            for (let i=0; i<this.props.data.length; i++) {
                checkBox[i] = false;
            }

            this.setState({ total: total });
            this.setState({ checkBox: checkBox });

        }

    }

    addValor(e) {

        let i = parseInt(e.target.value);
        let checkBox = this.state.checkBox.slice();

        checkBox[((this.state.pageNum - 1) * 10) + i] = 
            !this.state.checkBox[((this.state.pageNum - 1) * 10) + i];

        this.setState({ checkBox: checkBox });

        if (checkBox[((this.state.pageNum - 1) * 10) + i]) {

            if (this.props.data[((this.state.pageNum - 1) * 10) + i].err_valor !== 1
                    && this.props.data[((this.state.pageNum - 1) * 10) + i].err_valor !== 2
                    && this.props.data[((this.state.pageNum - 1) * 10) + i].err_valor !== 4) {

                this.setState({
                    total: this.state.total + this.props.data[((this.state.pageNum - 1) * 10) + i].valor
                });

            } else {

                this.setState({
                    total: this.state.total + this.props.data[((this.state.pageNum - 1) * 10) + i].corr_valor
                });

            }

        } else {

            if (this.props.data[((this.state.pageNum - 1) * 10) + i].err_valor !== 1
                    && this.props.data[((this.state.pageNum - 1) * 10) + i].err_valor !== 2
                    && this.props.data[((this.state.pageNum - 1) * 10) + i].err_valor !== 4) {

                this.setState({
                    total: this.state.total - this.props.data[((this.state.pageNum - 1) * 10) + i].valor
                });

            } else {

                this.setState({
                    total: this.state.total - this.props.data[((this.state.pageNum - 1) * 10) + i].corr_valor
                });

            }

        }

    }

    componentDidMount() {

        for (let i=0; i < this.props.data.lenght; i++) {
            this.state.checkBox.push(false);
        }

        let tp = this.props.data.length / this.props.pageSize;

        if (tp > parseInt(tp)) {
            this.setState({ totalPages: parseInt(tp) + 1 });
        } else {
            this.setState({ totalPages: parseInt(tp) });
        }

        let p = 0;

        for (let i = 0; i < this.props.data.length; i++) {

            if (i % this.props.pageSize === 0 && i !== 0) {

                p++;
                this.state.pages.push([]);
                this.state.pages[p].push(this.props.data[i]);

            } else {

                this.state.pages[p].push(this.props.data[i]);

            }

        }

    }

    getStatusName(s) {
        if (s === 1) return "Aprovado";
        else if (s === 2 || s === 3) return "Corrigido";
        else return "Lançado";
    }

    render() {
        return(
            <div id="gridmov">
                <form>
                    <input type="checkbox"
                        checked={ this.props.statusCB }
                        onChange={ this.props.changeStatusCB } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Status</label>
                    <input type="checkbox"
                        checked={ this.props.contaCB }
                        onChange={ this.props.changeContaCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Conta</label>
                    <input type="checkbox"
                        checked={ this.props.codigoCB }
                        onChange={ this.props.changeCodigoCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Código</label>
                    <input type="checkbox"
                        checked={ this.props.bancoCB }
                        onChange={ this.props.changeBancoCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Banco</label>
                    <input type="checkbox"
                        checked={ this.props.dataCB }
                        onChange={ this.props.changeDataCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Data</label>
                    <input type="checkbox"
                        checked={ this.props.historicoCB }
                        onChange={ this.props.changeHistoricoCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Histórico</label>
                    <input type="checkbox"
                        checked={ this.props.descricaoCB }
                        onChange={ this.props.changeDescricaoCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Descrição</label>
                    <input type="checkbox"
                        checked={ this.props.valorCB }
                        onChange={ this.props.changeValorCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Valor</label>
                    <input type="checkbox"
                        checked={ this.props.saldoCB }
                        onChange={ this.props.changeSaldoCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Saldo</label>
                    <input type="checkbox"
                        checked={ this.props.ghgCB }
                        onChange={ this.props.changeGhgCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>GHG</label>
                    <input type="checkbox"
                        checked={ this.props.cadastradoPorCB }
                        onChange={ this.props.changeCadastradoPorCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Cadastrado por</label>
                    <input type="checkbox"
                        checked={ this.props.corrigidoPorCB }
                        onChange={ this.props.changeCorrigidoPorCB }
                        Style={ "margin-left: 10px;" } />
                    <label Style={ "margin-left: 5px; color: #333333;" }>Corrigido por</label>
                </form><br />
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <input type="checkbox" 
                                        checked={ this.state.checkAll }
                                        onChange={ this.addAll } />
                            </th>
                            { this.props.statusCB && <th>Status</th> }
                            { this.props.contaCB && <th>Conta</th> }
                            { this.props.codigoCB && <th>Código</th> }
                            { this.props.bancoCB && <th>Banco</th> }
                            { this.props.dataCB && <th>Data</th> }
                            { this.props.historicoCB && <th>Histórico</th> }
                            { this.props.descricaoCB && <th>Descrição</th> }
                            { this.props.valorCB && <th>Valor</th> }
                            { this.props.saldoCB && <th>Saldo</th> }
                            { this.props.ghgCB && <th>GHG</th> }
                            { this.props.cadastradoPorCB && <th>Cadastrado por</th> }
                            { this.props.corrigidoPorCB && <th>Corrigido por</th> }
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.pages[this.state.pageNum - 1].map((row, i) => 
                            <tr key={ i } >

                                <td>
                                    <p className={ "grid_btn" } onClick={ () => this.abrir(row, this.state.pageNum, i) } >
                                        Visualizar
                                    </p>
                                </td>

                                <td>
                                    <center>
                                        <input type="checkbox" 
                                            value={ i }
                                            checked={ this.state.checkBox[((this.state.pageNum - 1) * 10) + i] }
                                            onChange={ this.addValor } />
                                    </center>
                                </td>

                                { this.props.statusCB &&
                                    <td className={ "gridmov-status-" + row.status }>{ this.getStatusName(row.status) }</td> }

                                { this.props.contaCB &&
                                    <td>
                                        { (row.err_conta_id !== 1 && row.err_conta_id !== 2 && row.err_conta_id !== 4) && this.formatarTexto(row.conta) }
                                        { (row.err_conta_id === 1 || row.err_conta_id === 2 || row.err_conta_id === 4) && this.formatarTexto(row.corr_conta) }
                                    </td> }

                                { this.props.codigoCB &&
                                    <td>
                                        { (row.err_conta_id !== 1 && row.err_conta_id !== 2 && row.err_conta_id !== 4) && row.cod_conta }
                                        { (row.err_conta_id === 1 || row.err_conta_id === 2 || row.err_conta_id === 4) && row.corr_cod_conta }
                                    </td> }

                                { this.props.bancoCB &&
                                    <td>
                                        { (row.err_banco !== 1 && row.err_banco !== 2 && row.err_banco !== 4) && row.banco_nome }
                                        { (row.err_banco === 1 || row.err_banco === 2 || row.err_banco === 4) && row.corr_banco_nome }
                                    </td> }

                                { this.props.dataCB &&
                                    <td>
                                        { (row.err_data !== 1 && row.err_data !== 2 && row.err_data !== 4) && row.data }
                                        { (row.err_data === 1 || row.err_data === 2 || row.err_data === 4) && row.corr_data }
                                    </td> }

                                { this.props.historicoCB &&
                                    <td>
                                        { (row.err_historico !== 1 && row.err_historico !== 2 && row.err_historico !== 4) && this.formatarTexto(row.historico) }
                                        { (row.err_historico === 1 || row.err_historico === 2 || row.err_historico === 4) && this.formatarTexto(row.corr_historico) }
                                    </td> }

                                { this.props.descricaoCB &&
                                    <td>
                                        { (row.err_descricao !== 1 && row.err_descricao !== 2 && row.err_descricao !== 4) && this.formatarTexto(row.descricao) }
                                        { (row.err_descricao === 1 || row.err_descricao === 2 || row.err_descricao === 4) && this.formatarTexto(row.corr_descricao) }
                                    </td> }

                                { this.props.valorCB &&
                                    <td>
                                        { (row.err_valor !== 1 && row.err_valor !== 2 && row.err_valor !== 4)
                                            && ("R$ " + this.formatarValor(row.valor.toFixed(2))) }
                                        { (row.err_valor === 1 || row.err_valor === 2 || row.err_valor === 4)
                                            && ("R$ " + this.formatarValor(row.corr_valor.toFixed(2))) }
                                    </td> }

                                { this.props.saldoCB &&
                                    <td>
                                        { "R$ " + this.formatarValor(row.saldo) }
                                    </td> }

                                { this.props.ghgCB &&
                                    <td>
                                        { (row.err_ghg !== 1 && row.err_ghg !== 2 && row.err_ghg !== 4) && row.ghg }
                                        { (row.err_ghg === 1 || row.err_ghg === 2 || row.err_ghg === 4) && row.corr_ghg }
                                    </td> }

                                { this.props.cadastradoPorCB && <td>{ row.cadastrado_por }</td> }

                                { this.props.corrigidoPorCB && <td>{ row.corrigido_por }</td> }

                            </tr>) }
                    </tbody>
                </table><br />
                <button type="button" onClick={ this.pageDown }>
                    { '<' }
                </button>
                <b> { this.state.pageNum } / { this.state.totalPages } </b>
                <button type="button" onClick={ this.pageUp }>
                    { '>' }
                </button>
                <br /><br />
                <h3>Total: { "R$ " + this.formatarValor(this.state.total.toFixed(2)) } </h3>
                <br />
            </div>
        );
    }

}

export default withRouter(GridMov);

